import { ChangeEvent, ReactElement } from 'react'
import CheckboxProps from './props'
import * as S from './style'

export default function Checkbox ({
  label,
  name,
  onChange,
  required = false
}: CheckboxProps): ReactElement {
  const handleChange = ({ target: { checked, name } }: ChangeEvent<HTMLInputElement>): void => {
    onChange((prevValue: any) => ({ ...prevValue, [name]: checked }))
  }

  return <S.Container>
    <S.Checkbox
      id={name}
      name={name}
      onChange={handleChange}
      required={required}
      value={name}
      type="checkbox"
    />
    <S.Label htmlFor={name}>{label}</S.Label>
  </S.Container>
}
